import { typesofUsers } from "../config";

export const SERIAL_FRAUD_TOOLTIP_TEXT = "RISK: Possible Serial Fraud";
export const SERIAL_FRAUD_UNKNOWN_TOOLTIP_TEXT = "RISK: Serial Fraud Status Unavailable";
export type SerialFraudIndicatorState = boolean | null;

export const canViewSerialFraudDashboardIndicator = (userRole?: string | null) => {
  const normalizedRole = String(userRole || "").trim().toLowerCase();
  return (
    normalizedRole === String(typesofUsers.docuverusSuperAdmin).toLowerCase() ||
    normalizedRole === String(typesofUsers.superAdmin).toLowerCase()
  );
};

type FraudIndicatorRow = {
  id?: string | number | null;
  ApplicantID?: string | number | null;
  ApplicantId?: string | number | null;
  applicant_id?: string | number | null;
  Trnid?: string | number | null;
  trn_id?: string | number | null;
  hasFraudRisk?: unknown;
};

const hasOwn = (source: object, propertyName: string) =>
  Object.prototype.hasOwnProperty.call(source, propertyName);

const normalizeSerialFraudIndicatorState = (value: unknown): SerialFraudIndicatorState => {
  if (value === true) {
    return true;
  }

  if (value === false) {
    return false;
  }

  return null;
};

export const getSerialFraudRowId = <TRow extends FraudIndicatorRow>(
  row?: TRow | null
): string => {
  const rowId =
    row?.id ??
    row?.ApplicantID ??
    row?.ApplicantId ??
    row?.applicant_id ??
    row?.Trnid ??
    row?.trn_id ??
    "";
  return String(rowId);
};

const resolveSerialFraudIndicatorState = <TRow extends FraudIndicatorRow>(
  row?: TRow | null,
  fraudFlagsById: Record<string, unknown> = {}
): SerialFraudIndicatorState => {
  const rowId = getSerialFraudRowId(row);
  const hasFetchedState = rowId.length > 0 && hasOwn(fraudFlagsById, rowId);
  const fetchedState = hasFetchedState
    ? normalizeSerialFraudIndicatorState(fraudFlagsById[rowId])
    : undefined;
  const hasRowState = Boolean(row) && hasOwn(row as object, "hasFraudRisk") && row?.hasFraudRisk !== undefined;
  const rowState = hasRowState ? normalizeSerialFraudIndicatorState(row?.hasFraudRisk) : undefined;

  if (hasFetchedState) {
    return fetchedState ?? null;
  }

  if (hasRowState) {
    return rowState ?? null;
  }

  return false;
};

export const getSerialFraudIndicatorState = <TRow extends FraudIndicatorRow>(
  row?: TRow | null,
  fraudFlagsById: Record<string, unknown> = {}
): SerialFraudIndicatorState => resolveSerialFraudIndicatorState(row, fraudFlagsById);

export const getApplicantDetailSerialFraudIndicatorState = <TRow extends FraudIndicatorRow>(
  row?: TRow | null,
  fraudFlagsById: Record<string, unknown> = {}
): SerialFraudIndicatorState => resolveSerialFraudIndicatorState(row, fraudFlagsById);
